// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__hIFbi"};